import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./../../Styles/pages/components.scss";
import { ReactComponent as DoctorImgNotFound } from "./../../assets/images/icons/doctor.svg";
import { useSelector } from "react-redux";
import IsLogin from "../../utilities/functions/isLogin";
import { Fab, TextField } from "@mui/material";
import { ReactComponent as AddCircleIcon } from "./../../assets/images/icons/Google SVGs/add_circle.svg";
import { ReactComponent as CancelIcon } from "./../../assets/images/icons/Google SVGs/cancel.svg";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";
import moment from "moment-jalaali";

import ShiftFormCard from "../../components/cards/shiftFormCard";
import ShiftCard from "../../components/cards/shiftCard";
import PersianDatePicker from "../../components/DateTimePicker/PersianDatePicker";
import PersianTimePicker from "../../components/DateTimePicker/PersianTimePicker";
import VacationCard from "../../components/cards/vacationCard";

const ShiftManagement = () => {
  const isMobile = window.innerWidth >= 992 ? false : true;

  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  const navigate = useNavigate();
  // const { roles } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [showAddShiftModal, setShowAddShiftModal] = useState(false);
  const [showVacationsModal, setShowVacationsModal] = useState(false);

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const dr = queryParams.get("dr") ? queryParams.get("dr") : null;

  const [doctorFile, setDoctorFile] = useState();
  const [doctorFirstName, setDoctorFirstName] = useState();
  const [doctorLastName, setDoctorLastName] = useState();
  const [doctorSpecialties, setDoctorSpecialties] = useState([]);
  const [doctorDepPl, setDoctorDepPl] = useState([]);

  // const [departments, setDepartments] = useState([]);
  // const [places, setPlaces] = useState([]);

  const [shifts, setShifts] = useState();
  const [dayChecked, setDayChecked] = useState(false);
  const [forms, setForms] = useState([{ id: 1, data: {} }]);
  const [formCounter, setFormCounter] = useState(2);

  // Vacations
  const [vacationDailyList, setVacationDailyList] = useState();
  const [vacationHourlyList, setVacationHourlyList] = useState();
  const [vacationSwitch, setVacationSwitch] = useState(true); // true is daily and false is hourly
  // const [vacationAllPlaceSwitch, setVacationAllPlaceSwitch] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedStartVacationDate, setSelectedStartVacationDate] = useState();
  const [selectedEndVacationDate, setSelectedEndVacationDate] = useState();
  const [selectedVacationDate, setSelectedVacationDate] = useState(moment());
  const [selectedStartTime, setSelectedStartTime] = useState();
  const [selectedEndTime, setSelectedEndTime] = useState();

  const handleSelect = (placeId, departmentId) => {
    setSelectedPlace(placeId);
    setSelectedDepartment(departmentId);
  };

  const days = [
    { id: "sat", name: "شنبه" },
    { id: "sun", name: "یک شنبه" },
    { id: "mon", name: "دو شنبه" },
    { id: "tue", name: "سه شنبه" },
    { id: "wed", name: "چهار شنبه" },
    { id: "thu", name: "پنج شنبه" },
    { id: "fri", name: "جمعه" },
  ];

  // functions
  const addForm = (data) => {
    data
      ? setForms([...forms, { id: formCounter, data: data }])
      : setForms([...forms, { id: formCounter, data: {} }]);
    setFormCounter(formCounter + 1);
  };

  const removeForm = (id) => {
    setForms(forms.filter((form) => form.id !== id));
  };

  const updateFormData = (id, data) => {
    setForms(forms.map((form) => (form.id === id ? { ...form, data } : form)));
  };

  const transformData = (data) => {
    return Object.keys(data).map((day) => {
      return {
        day,
        shifts: data[day],
      };
    });
  };

  const translatedDay = (day) => {
    const foundDay = days.find((e) => e.id === day);
    return foundDay ? foundDay.name : "";
  };

  const findTitlePlaceDep = (id, isPL) => {
    if (isPL == true) {
      const placeTitle = doctorDepPl.find((e) => e.place.id == id);
      return placeTitle ? placeTitle.place.title : "";
    } else {
      const departmentTitle = doctorDepPl.find((e) => e.department.id == id);
      return departmentTitle ? departmentTitle.department.title : "";
    }
  };

  const loadShifts = (shifts) => {
    let tempForms = [];
    let tempFormCounter = 2;
    for (let i = 0; i < shifts.length; i++, tempFormCounter++) {
      // addForm(shifts[i]);
      tempForms.push({ id: tempFormCounter, data: shifts[i] });
    }
    setForms(tempForms);
    setFormCounter(tempFormCounter);
  };

  const handlePlaceChange = (e) => {
    setSelectedPlace(e);
  };

  //  APIs
  const getDoctorDetail = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDoctorProfile + dr,
        { user_id: dr, type: "shift" },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDoctorFirstName(response.data.data.first_name);
          setDoctorLastName(response.data.data.last_name);
          response.data.data.doctor_specialties &&
            setDoctorSpecialties(response.data.data.doctor_specialties);
          setDoctorDepPl(response.data.data.department_places);
          response.data.data.file
            ? setDoctorFile(response.data.data.file)
            : setDoctorFile();
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDoctorShifts = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDoctorShifts,
        { user_id: dr },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setShifts(transformData(response.data.data.active_times));
          // setPlaces(response.data.data.places);
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDoctorVacations = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDoctorVacations,
        { doctor_id: dr },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          response.data.data.vacations.daily
            ? setVacationDailyList(response.data.data.vacations.daily)
            : setVacationDailyList();
          response.data.data.vacations.hourly
            ? setVacationHourlyList(response.data.data.vacations.hourly)
            : setVacationHourlyList();
          // setShifts(transformData(response.data.data.active_times));
          // setPlaces(response.data.data.places);
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const createShiftAPI = () => {
    let active_times = [];

    forms.forEach((element) => {
      active_times.push(element.data);
    });

    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.upsertActiveTimes,
        {
          doctor_id: dr,
          active_times: {
            [dayChecked]: active_times,
          },
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          // Handle response data
          toast.success(response.data.message);
          // setShowAddShiftModal(false);
          // setForms([{ id: 1, data: {} }]);
          // setFormCounter(2);
          getDoctorShifts();
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const createVacationAPI = () => {
    setLoading(true);

    const payload = {
      doctor_id: dr,
      vacations: [
        {
          place_id: selectedPlace,
          department_id: selectedDepartment,
          type: vacationSwitch ? "daily" : "hourly",
          start: vacationSwitch
            ? selectedStartVacationDate.format("jYYYY/jMM/jDD")
            : selectedStartTime,
          end: vacationSwitch
            ? selectedEndVacationDate.format("jYYYY/jMM/jDD")
            : selectedEndTime,
          ...(vacationSwitch
            ? {}
            : {
              date: selectedVacationDate.format("jYYYY/jMM/jDD"),
            }),
        },
      ],
    };

    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.storeDoctorVacation,
        payload,
        { headers }
      )
      .then((response) => {
        // selectedStartVacationDate
        setLoading(false);
        if (response.data.status === "success") {
          setLoading(false);
          toast.success(response.data.message);
          getDoctorVacations();
        } else {
          setLoading(false);
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const deleteVacationAPI = (vacationId) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDoctorVacation +
        vacationId,
        {},
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorVacations();
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      if (loggedIn === false || loggedIn === "error api") {
        localStorage.clear();
        navigate("/login");
      }
    };
    checkLoginStatus();
    getDoctorDetail();
    getDoctorShifts();
    getDoctorVacations();
  }, []);

  return (
    <div className="pt-3 mx-12n">
      <div className="d-flex flex-column border rounded-lg-2 w-100 pb-3">
        <div className="d-flex row background-bootstrap-gray-100 rounded border-1 border-bootstrap-gray-400 border-lg p-2 m-3 w-auto">
          <div className="d-flex col px-0 justify-content-start">
            {doctorFile && doctorFile.length !== 0 ? (
              <img
                className="doctor-image-box col col-auto object-fit-cover"
                src={doctorFile}
              />
            ) : (
              <DoctorImgNotFound className="doctor-image-box col col-auto object-fit-cover rounded-pill p-2 background-bootstrap-gray-200 me-2" />
            )}
            <div className="d-flex flex-column ms-2">
              <span
                className="fs-14 fw-medium color-bootstrap-gray-800 mb-1"
                type="button"
                onClick={() => navigate(`/doctor?dr=${dr}`)}
              >
                {doctorFirstName} {doctorLastName}
              </span>

              {doctorSpecialties &&
                doctorSpecialties.map((e, index) => (
                  <span
                    key={index}
                    className="fs-12 fw-normal color-bootstrap-gray-600"
                  >
                    {e.education_title} {e.specialty_title}
                  </span>
                ))}
            </div>
          </div>
          {/* <div className="col-auto d-flex px-0 flex-column align-items-center">
            <button className="btn py-1 px-2 btn-blue-300 fs-12">
              تغییر پزشک
            </button>
          </div> */}
        </div>

        {/* a day section */}

        {/* {shifts && shifts} */}
        {shifts &&
          shifts.map((shift, index) => (
            <React.Fragment key={index}>
              <div className="d-flex row flex-row p-0 m-3 w-auto align-items-center">
                <div className="d-flex col col-auto h-fit fs-14 fw-normal px-3 py-1 btn-blue-check rounded-pill border border-1 fs-12 fw-normal justify-content-center align-items-center active">
                  {translatedDay(shift.day)}
                </div>
                <hr className="d-flex col my-auto mx-2 color-iso-blue-200 opacity-100" />
                <div
                  className="d-flex col col-auto h-fit fs-12 fw-normal px-3 py-1 btn-blue-check rounded-3 border border-1 fs-12 fw-normal justify-content-center align-items-center active"
                  type="button"
                  onClick={() => {
                    loadShifts(shift.shifts);
                    setShowAddShiftModal(true);
                    setDayChecked(shift.day);
                  }}
                >
                  ویرایش
                </div>
              </div>

              <div className="d-flex row flex-row p-0 mx-2 w-auto g-3 align-items-center">
                {shift.shifts.map((shift, index) => (
                  <div
                    key={index}
                    className="d-flex col col-lg-6 col-12 h-fit justify-content-center align-items-center"
                  >
                    <ShiftCard
                      place={findTitlePlaceDep(shift.place_id, true)}
                      department={findTitlePlaceDep(shift.department_id, false)}
                      start={shift.start}
                      end={shift.end}
                      hasVoiceCall={shift.has_voice_call}
                      hasVideoCall={shift.has_video_call}
                      hasText={shift.has_text}
                      hasInPerson={shift.has_in_person}
                      isPrivate={shift.is_private}
                    />
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}

        {/* a day section end */}
      </div>

      <div className={`d-flex position-sticky ${isMobile ? 'tw-bottom-[90px]' : 'tw-bottom-3'}`}>
        <Fab
          variant="extended"
          size="medium"
          className="d-flex ms-auto me-12px mt-2 fs-16 fw-medium btn-blue-300 rounded-pill py-2 px-lg-4 px-2"
          type="button"
          onClick={() => {
            setShowVacationsModal(true);
          }}
        >
          مرخصی‌ها
          <AddCircleIcon width={30} height={30} className="ms-2" />
        </Fab>

        <Fab
          variant="extended"
          size="medium"
          className="d-flex me-12px mt-2 fs-16 fw-medium btn-blue-300 rounded-pill py-2 px-lg-4 px-2"
          type="button"
          onClick={() => {
            setForms([{ id: 1, data: {} }]);
            setFormCounter(2);
            setShowAddShiftModal(true);
          }}
        >
          ثبت شیفت جدید
          <AddCircleIcon width={30} height={30} className="ms-2" />
        </Fab>
      </div>

      {/* Create new Shifts modal */}
      <div
        className={`modal fade${showAddShiftModal ? " show d-block" : ""}`}
        aria-labelledby="add-shift-modal-label"
        aria-hidden="false"
        role="dialog"
        onClick={(e) => {
          if (!e.target.closest(".modal-content")) {
            setShowAddShiftModal(false);
          }
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom box-shadow-bottom border-bootstrap-gray-400 mx-0 px-3 pt-3 d-flex row pb-2">
              <div className="d-flex p-0 mb-3">
                <span className="w-100 fs-16 fw-medium">شیفت جدید</span>
                <CancelIcon
                  width={24}
                  type="button"
                  onClick={() => {
                    setShowAddShiftModal(false);
                  }}
                />
              </div>

              <hr className="d-flex my-0 color-bootstrap-gray-300"></hr>

              <div className="d-flex row form-check px-0 mt-3 mx-0 mb-0">
                {days.map((day) => (
                  <div key={day.id} className="d-flex col-auto px-0 pe-2">
                    <span
                      className={`btn-blue-check rounded-pill border border-1 px-2 py-0 mb-2 fs-14 fw-normal${dayChecked === day.id ? " active" : ""
                        }`}
                      type="button"
                      onClick={() => {
                        setDayChecked(day.id);
                      }}
                    >
                      {day.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-body px-0 py-0">
              {/* Detail inputs */}

              {forms &&
                forms.map((form) => (
                  <div key={form.id} className="d-flex w-100 px-12px mt-3">
                    <ShiftFormCard
                      key={form.id}
                      formId={form.id}
                      formData={form.data}
                      depPlace={doctorDepPl}
                      updateForm={(data) => updateFormData(form.id, data)}
                      removeForm={() => removeForm(form.id)}
                    />
                  </div>
                ))}

              <div className="d-flex w-100 px-12px my-3 justify-content-end">
                <div
                  className="btn btn-blue-300 py-1 px-3 fs-14"
                  onClick={() => addForm()}
                >
                  اضافه کردن
                  <AddCircleIcon width={20} height={20} className="ms-2" />
                </div>
              </div>
            </div>
            <div className="modal-footer p-3 m-0">
              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center m-0"
                onClick={() => {
                  createShiftAPI();
                }}
                disabled={!dayChecked}
              >
                تایید نهایی
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Vacations Management modal */}
      <div
        className={`modal fade${showVacationsModal ? " show d-block" : ""}`}
        aria-labelledby="vacation-modal-label"
        aria-hidden="false"
        role="dialog"
        onClick={(e) => {
          if (!e.target.closest(".modal-content")) {
            setShowVacationsModal(false);
          }
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0 box-shadow-bottom border-bootstrap-gray-400 mx-0 px-3 pt-3 d-flex row pb-2">
              <div className="d-flex p-0 mb-2">
                <span className="w-100 fs-16 fw-medium">مرخصی</span>
                <CancelIcon
                  width={24}
                  height={24}
                  type="button"
                  onClick={() => {
                    setShowVacationsModal(false);
                  }}
                />
              </div>

              <hr className="d-flex my-0 color-bootstrap-gray-300"></hr>
            </div>
            <div className="modal-body bg-white px-0 py-0">
              {/* Detail inputs */}
              <div className="d-flex col p-2 mx-12px border border-1 rounded-2 border-bootstrap-gray-300 background-bootstrap-gray-100 justify-content-start">
                {doctorFile && doctorFile.length !== 0 ? (
                  <img
                    className="doctor-image-box col col-auto object-fit-cover"
                    src={doctorFile}
                  />
                ) : (
                  <DoctorImgNotFound className="doctor-image-box col col-auto object-fit-cover rounded-pill p-2 background-bootstrap-gray-200 me-2" />
                )}
                <div className="d-flex flex-column ms-2">
                  <span className="fs-14 fw-medium color-bootstrap-gray-800 mb-1">
                    {doctorFirstName} {doctorLastName}
                  </span>

                  {doctorSpecialties &&
                    doctorSpecialties.map((e, index) => (
                      <span
                        key={index}
                        className="fs-12 fw-normal color-bootstrap-gray-600"
                      >
                        {e.education_title} {e.specialty_title}
                      </span>
                    ))}
                </div>
              </div>
              <div
                className="switch-radio rounded-pill p-1 mx-12px d-flex justify-content-center w-auto mt-2 mb-3 background-bootstrap-gray-200"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                <input
                  type="radio"
                  className="btn-check "
                  name="btnradio"
                  id="btnradio1"
                  autoComplete="off"
                  defaultChecked
                  onChange={(e) => {
                    e.target.checked && setVacationSwitch(true);
                  }}
                />
                <label
                  className="btn btn-outline-primary rounded-pill col col-6 py-1 fs-12 border-0"
                  htmlFor="btnradio1"
                >
                  مرخصی روزانه
                </label>

                <input
                  type="radio"
                  className="btn-check"
                  name="btnradio"
                  id="btnradio2"
                  autoComplete="off"
                  onChange={(e) => {
                    e.target.checked && setVacationSwitch(false);
                  }}
                />
                <label
                  className="btn btn-outline-primary rounded-pill col col-6 py-1 fs-12 border-0"
                  htmlFor="btnradio2"
                >
                  مرخصی ساعتی
                </label>
              </div>
            </div>
            {/* <div className="d-flex col col-12 px-12px mb-1 justify-content-start">
              <label className="fs-12 fw-normal" htmlFor="AllPlaceSwitch">
                درخواست مرخصی در تمام مراکز
              </label>
              <div className="form-check form-switch d-flex align-items-center ms-auto">
                <input
                  className="form-check-input m-0"
                  type="checkbox"
                  role="switch"
                  id="AllPlaceSwitch"
                  checked={vacationAllPlaceSwitch}
                  onChange={(e) => {
                    setVacationAllPlaceSwitch(e.target.checked);
                  }}
                />
              </div>
            </div> */}

            <div className="dropdown custom-dropdown w-auto mx-12px mb-3 fs-12 background-bootstrap-gray-100 rounded-2">
              <button
                className="btn dropdown-toggle p-2 w-100 d-flex text-start border-0 rounded-0 align-items-center color-bootstrap-gray-600"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {doctorDepPl &&
                  selectedPlace &&
                  selectedDepartment &&
                  `${doctorDepPl.find(
                    (place) => place.place.id === parseInt(selectedPlace)
                  ).place.title
                  } / ${doctorDepPl.find(
                    (place) =>
                      place.department.id === parseInt(selectedDepartment)
                  ).department.title
                  }`}
                {!doctorDepPl || (!selectedPlace && !selectedDepartment)
                  ? "انتخاب مرکز درمانی / دپارتمان"
                  : ""}
                <ChevronDownIcon
                  className="arrow ms-auto"
                  width={24}
                  height={24}
                />
              </button>
              <ul className="dropdown-menu w-100">
                {doctorDepPl.map(({ place, department }) => (
                  <li key={`${place.id}-${department.id}`}>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => handleSelect(place.id, department.id)}
                    >
                      {place.title} / {department.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {vacationSwitch ? (
              <div
                className="d-flex mx-12px row gx-2"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="d-flex col col-6">
                  <PersianDatePicker
                    value={selectedStartVacationDate}
                    label="تاریخ شروع"
                    onChange={(date) => {
                      setSelectedStartVacationDate(date);
                    }}
                  />
                </div>
                <div className="d-flex col col-6">
                  <PersianDatePicker
                    value={selectedEndVacationDate}
                    label="تاریخ پایان"
                    onChange={(date) => {
                      setSelectedEndVacationDate(date);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div
                className="d-flex mx-12px row gx-2"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="d-flex col col-4">
                  <PersianDatePicker
                    value={selectedVacationDate}
                    label="تاریخ"
                    onChange={(date) => {
                      setSelectedVacationDate(date);
                    }}
                  />
                </div>
                <div className="d-flex col col-4">
                  <PersianTimePicker
                    label="ساعت شروع"
                    value={selectedStartTime}
                    onChange={(Time) => {
                      setSelectedStartTime(Time);
                    }}
                  />
                </div>
                <div className="d-flex col col-4">
                  <PersianTimePicker
                    label="ساعت پایان"
                    value={selectedEndTime}
                    onChange={(Time) => {
                      setSelectedEndTime(Time);
                    }}
                  />
                </div>
              </div>
            )}

            <button
              className="btn btn-blue-300 text-white fs-16 fw-normal rounded-2 w-auto py-1 px-3 my-3 me-12px ms-auto"
              disabled={loading || !selectedDepartment || !selectedPlace}
              onClick={createVacationAPI}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <AddCircleIcon className="me-1" width={24} height={24} />
              )}
              ثبت مرخصی
            </button>

            <span className="fs-16 fw-medium color-bootstrap-gray-600 mb-3 ms-12px">
              لیست مرخصی‌ها
            </span>
            <div className="d-flex flex-column mx-12px pb-1">
              {vacationDailyList &&
                vacationDailyList.map((vacation, index) => (
                  <VacationCard
                    key={index}
                    start={vacation.start_day + " " + vacation.start}
                    end={vacation.end_day + " " + vacation.end}
                    place={vacation.title_place}
                    department={vacation.title_department}
                    type="daily"
                    onEdit={() => {
                      setSelectedDepartment(vacation.department_id);
                      setSelectedPlace(vacation.place_id);
                      setSelectedStartVacationDate(
                        moment(vacation.start, "jYYYY/jMM/jDD").format(
                          "YYYY-MM-DD"
                        )
                      );
                      setSelectedEndVacationDate(
                        moment(vacation.end, "jYYYY/jMM/jDD").format(
                          "YYYY-MM-DD"
                        )
                      );
                      setVacationSwitch(true);
                    }}
                    onRemove={() => {
                      deleteVacationAPI(vacation.id);
                    }}
                  />
                ))}
              {vacationHourlyList &&
                vacationHourlyList.map((vacation, index) => (
                  <VacationCard
                    key={index}
                    date={vacation.day + " " + vacation.date}
                    start={vacation.start_hour}
                    end={vacation.end_hour}
                    place={vacation.title_place}
                    department={vacation.title_department}
                    type="hourly"
                    onEdit={() => {
                      setSelectedDepartment(vacation.department_id);
                      setSelectedPlace(vacation.place_id);
                      setSelectedVacationDate(
                        moment(vacation.date, "jYYYY/jMM/jDD").format(
                          "YYYY-MM-DD"
                        )
                      );
                      setSelectedStartTime(
                        moment(vacation.start_hour, "HH:mm")
                      );
                      setSelectedEndTime(moment(vacation.end_hour, "HH:mm"));
                      setVacationSwitch(false);
                    }}
                    onRemove={() => {
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`fade${showAddShiftModal || showVacationsModal ? " modal-backdrop show" : ""
          }`}
        onClick={() => {
          setShowAddShiftModal(false);
          setShowVacationsModal(false);
        }}
      />
    </div>
  );
};

export default ShiftManagement;
